if (typeof ScrollingText !== "function") {
	class ScrollingText extends HTMLElement {
		constructor() {
			super();

			let box = this;
			let inner_element = (box.children && box.children[0]) || null;
			if (!inner_element) throw "No child node found";

			// Initiale Variablen setzen
			let position = 0;
			const speed = window.innerWidth > 768 ? parseInt(this.dataset.scrollingSpeed) : parseInt(this.dataset.scrollingSpeed) / 1.5;
			const direction = this.dataset.scrollingDirection;
			let running = false;
			let last_time = null;

			// Berechnet die Breite des Elements nur einmal
			let box_width = box.offsetWidth;
			let inner_element_width = inner_element.offsetWidth;

			// Setup: Klone das Element nur einmal!
			while (box.children.length < Math.ceil(box_width / inner_element_width) + 1) {
				box.appendChild(inner_element.cloneNode(true));
			}

			// Animation mit GPU-Optimierung (transform statt left/right)
			function nextFrame(delta) {
				position += (speed * delta) / 1000;
				if (position >= inner_element_width) {
					position %= inner_element_width;
				}

				Array.prototype.forEach.call(box.children, function (el) {
					el.style.transform = `translate3d(${-position}px, 0, 0)`;
				});
			}

			// Hauptloop optimiert
			function loop() {
				if (!running) return;
				const now = performance.now();
				const delta = last_time ? now - last_time : 16; // Fallback auf 16ms (~60fps)
				last_time = now;

				nextFrame(delta);
				requestAnimationFrame(loop);
			}

			// Start- und Stop-Funktionen
			function start() {
				if (!running) {
					running = true;
					last_time = performance.now();
					requestAnimationFrame(loop);
				}
			}

			function stop() {
				running = false;
			}

			// Starten der Animation
			start();

			// Hover-Pause-Funktion
			if (this.dataset.pauseOnHover === "true") {
				this.addEventListener("mouseover", stop);
				this.addEventListener("mouseout", start);
			}

			// Intersection Observer zur besseren Performance (nur animieren, wenn sichtbar)
			const observer = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							start();
						} else {
							stop();
						}
					});
				},
				{ threshold: 0.1 }
			);
			observer.observe(this);
		}
	}

	if (!customElements.get("scrolling-text")) {
		customElements.define("scrolling-text", ScrollingText);
	}
}
